import sileo from 'sileo';

const CompanyTeams = new sileo.Model('bposeats', 'company-teams');

const actions = {
    getCompanyTeamDetails(context, pk) {
        return CompanyTeams.objects.get(pk);
    }
};

export default {
    namespaced: true,
    actions
};
